import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/Marquee";
import { About } from "../components/home/About";
import { VenturesIndex } from "../components/home/VenturesIndex";
import { Statement } from "../components/home/Statement";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <About />
      <VenturesIndex />
      <Statement />
    </main>
  );
}
